import React, {Component} from 'react';
import moment from 'moment';

class Counter extends Component {
    constructor(props){
        super(props);

        this.state = {
            timer: null
        }

        this.timer = null;
    }

    updateTimer = () => {
        if(this.props.direction === 'up'){
            this.setState({timer:  this.state.timer + 1});
        }else{
            this.setState({timer:  this.state.timer - 1});
        }
    }

    componentDidMount(){
        if(this.props.seconds > 0){
            if (!this.timer) {
                // Initiate lecture timer
                this.timer = setInterval(this.updateTimer, 1000);
                this.setState({timer: this.props.seconds});
            }
        }
    }

    componentDidUpdate(props){
        if(this.props.seconds > 0 && !this.timer){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({timer: this.props.seconds});
        }
    }

    componentWillUnmount(){
        clearInterval(this.timer);
    }

    render(){
        const {subject, cu, subjectCompleted, timeClass, fullDays, plain} = this.props;
        const {timer} = this.state;
        
        if(plain){
            if(timer < 86400){
                return moment.utc(timer * 1000).format('HH:mm:ss')
            }else{
                return moment.duration(timer * 1000).humanize()
            }
            
        }else if(fullDays){
            if(this.props.noStyle){
                if(timer > 0){
                    return (
                        <span>
                                                            
                            {parseInt(moment.duration(Math.ceil(timer*1000)).asDays())}d&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('hours')}h&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('minutes')}m&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('seconds')}s&nbsp;
                        </span>
                    )
                }else{
                    return (
                        <span>EXPIRED</span>
                    )
                }

            }else{
                if(timer > 0){
                    return (
                        <div id="selected_test_date_timer" style={{display: 'block'}}>
                                                            
                            {parseInt(moment.duration(Math.ceil(timer*1000)).asDays())}d&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('hours')}h&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('minutes')}m&nbsp;
                            {moment.duration(Math.ceil(timer*1000)).get('seconds')}s&nbsp;
                        </div>
                    )
                }else{
                    return (
                        <div id="selected_test_date_timer" style={{display: 'block'}}>EXPIRED</div>
                    )
                }
            }
            
        }else{
            return (
                <h3 className={`font-16 sm-bottom0 text-${(subject.id === cu.currentSubject) ? timeClass : ''}`}>{
                    (cu.currentSubject === subject.id && cu.currentSubjectDeadline) ?
                        <span>
                            
                        {
                             timer === Infinity ||  timer == null || isNaN( timer) ?
                                'Unknown'
                                :
                                     timer < 86400 ?
                                        moment.utc( timer * 1000).format('HH:mm:ss')
                                    :
                                        moment.duration( timer * 1000).humanize()
                            
                        }
                        </span>
                        : 
                            (subjectCompleted) ?
                                'Completed'
                                :
                                'Not Set'
                    
                        }

                </h3>
            )
        }
    }
}

export default Counter;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/Counter.js